/**
 * True when `hostname` is yardzen.com or one of its subdomains.
 *
 * Written as an exact match plus a dot-prefixed suffix on purpose. The
 * shorthand versions both let impostors through:
 *
 *   host.includes("yardzen.com")  matches evil-yardzen.com.attacker.net
 *   host.endsWith("yardzen.com")  matches notyardzen.com
 *
 * Callers use this to decide whether to scope a cookie to `.yardzen.com`, so a
 * loose match means writing auth cookies on behalf of a host that isn't ours.
 *
 * Pass a hostname, not a Host header — strip any `:port` first
 * (`host.split(":")[0]`), since `window.location.hostname` has no port but a
 * `host` header does.
 */
export function isYardzenHost(hostname: string): boolean {
  return hostname === "yardzen.com" || hostname.endsWith(".yardzen.com");
}
